import { useEffect, useRef } from 'react';
import Overlay from '../../ui/Overlay';
import Button from '../../ui/Button';
import { extendBountyExpiration } from '../../apis/bounties/bounties';
import ModalBox from '../../ui/ModalBox';
import { useLoadingState } from '../../hooks/useLoader';
import Heading from '../../ui/Heading';
import TextWithTooltip from '../../ui/TextWithTooltip';
import DatePicker from 'react-datepicker';
import { useController, useForm } from 'react-hook-form';
import Loader from '../../ui/Loader';
import { dateToIsoString } from '../../helpers/dateToIsoString';
import { toast } from 'sonner';
import { createPortal } from 'react-dom';
import ButtonNew from '../../ui/ButtonNew';
function RePublishBountyModal({
    close,
    bountyName,
    isValidationDateRequired,
    bountyId,
    onRepublish
}) {
    const modalRef = useRef(null); // Reference for the modal content
    const { loading, startLoading, stopLoading } = useLoadingState();
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        mode: 'onChange',

    });
    const { field: expirationTimeField } = useController({
        name: 'expirationTime',
        control,
        rules: {
            required: 'Please enter a date',
        },
    });

    const { field: validationTillDateField } = useController({
        name: 'validationTillDate',
        control,
        rules: {
            required: isValidationDateRequired ? 'Please enter a date' : false,
        },
    });





    useEffect(() => {


        // Handle click outside the modal
        function handleClickOutside(e) {
            // Check if the click was outside the modal content
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                close(); // Close the modal if clicked outside
            }
        }

        // Add event listener in the capture phase to ensure proper handling
        document.addEventListener('mousedown', handleClickOutside, true);

        return () => {
            // Clean up the event listener on unmount
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [close, bountyId]);

    const onSubmit = async (data) => {

        const { expirationTime, validationTillDate } = data;
        const expirationDate = new Date(expirationTime);
        const validationDate = new Date(validationTillDate);
        const currentDate = new Date();
        console.log('Expiration Date:', expirationDate, 'Validation Date:', validationDate, 'Current Date:', currentDate);

        const expirationTimeIso = dateToIsoString(expirationDate);
        const validationTillDateIso = dateToIsoString(validationDate);
        console.log('Expiration Time ISO:', expirationTimeIso, 'Validation Till Date ISO:', validationTillDateIso);
        // Validation: expirationTime should be in the future
        if (expirationDate <= currentDate) {
            toast.error('Expiration time must be in the future.');
            return;
        }

        // Validation: validationTillDate should be after expirationTime
        if (validationDate <= expirationDate) {
            toast.error('Validation till date must be after the expiration time.');
            return;
        }

        try {
            startLoading();
            const { newBountyStatus } = await extendBountyExpiration(bountyId, "REPUBLISH", expirationTimeIso, isValidationDateRequired ? validationTillDateIso : false);
            if (newBountyStatus) {
                onRepublish('republish', bountyId);
                toast.success('Bounty successfully re-published. ');
            }
        } catch (error) {
            console.log(error);
        } finally {
            close(); // Close modal after duplication
            stopLoading();
        }

    };

    return createPortal(
        <Overlay>
            <div
                ref={modalRef} // Attach ref to modal content
                className="absolute rounded-lg left-[50%]     bg-primaryBg translate-x-[-50%] translate-y-[-50%] top-[50%]"
                onClick={(e) => e.stopPropagation()} // Stop propagation to avoid closing the modal when clicked inside
            >
                <ModalBox
                    close={close}
                    width="w-[32.75rem]"
                    isConfirmModal={false}
                    onSubmit={onSubmit}
                    primaryBtnText={'Publish'}
                    isTypeSubmit={true}
                    loading={loading}
                    secondaryBtnText={'Cancel'}
                >

                    <div>
                        <div className="pb-4 border-b border-borderUnderline">

                            <h3 className="text-xl pr-6 break-words font-bold text-textPrimary"> Re-publish Bounty  '{bountyName}' </h3>
                            <p className='text-textSecondary'>Re-publishing the bounty date will allow more time for new submissions</p>

                        </div>

                        <form onSubmit={handleSubmit(onSubmit)} className="pt-4">
                            <>
                                <div className="mb-5">
                                    <div className="flex gap-3 mb-1">
                                        <TextWithTooltip
                                            expandedTextWidth={'400px'}
                                            heading={
                                                <Heading
                                                    type="xsmall"
                                                    className="capitalize  text-textPrimary"
                                                >
                                                    Once published, how long should the bounty be live?{' '}
                                                    <sup className="text-lg relative top-[1px]">*</sup>
                                                </Heading>
                                            }
                                        >
                                            <p className="text-sm">
                                                This is the bounty expiration time after which it will disappear
                                                from Impact Miner and users will not be able to participate
                                            </p>
                                        </TextWithTooltip>
                                    </div>

                                    <div>
                                        <DatePicker
                                            showTimeSelect
                                            minDate={new Date()}
                                            className="border border-borderUnderline w-[230px] shadow-sm text-sm bg-grayBgNormal placeholder:text-textTertiary font-semibold rounded-md px-4 py-2 focus:outline-none focus:border-blueNormal focus:ring-0"
                                            // maxTime={new Date(0, 0, 0, 19, 0)}
                                            placeholderText="Set Date & Time"
                                            selected={expirationTimeField.value}
                                            onChange={(date) => expirationTimeField.onChange(date)}
                                            dateFormat="MMMM d, yyyy h:mmaa"
                                            timeIntervals={1}

                                        // customInput={<CustomDateInput placeholder="Set Date & Time" className="bg-grayBgNormal" />}
                                        />
                                        {errors.expirationTime && (
                                            <p className="text-foundryRed">{errors.expirationTime.message}</p>
                                        )}
                                    </div>
                                </div>

                                {isValidationDateRequired && <div className="my-5">
                                    <div className="flex gap-3 mb-1">
                                        <TextWithTooltip
                                            heading={
                                                <Heading
                                                    type="xsmall"
                                                    className="capitalize  text-textPrimary"
                                                >
                                                    Set Deadline for validating all submissions{' '}
                                                    <sup className="text-lg relative top-[1px]">*</sup>
                                                </Heading>
                                            }
                                        >
                                            <p className="text-sm">
                                                Validation determines the score of each submission and in turn
                                                the winners.
                                            </p>
                                            <p className="text-sm mt-3">
                                                Setting a deadline will inform users how long it will take for
                                                the results to be announced
                                            </p>
                                        </TextWithTooltip>
                                    </div>
                                    <div>
                                        <DatePicker
                                            minDate={new Date(expirationTimeField.value)}
                                            showTimeSelect
                                            className="border border-borderUnderline w-[230px] shadow-sm text-sm bg-grayBgNormal placeholder:text-textTertiary font-semibold rounded-md px-4 py-2 focus:outline-none focus:border-blueNormal focus:ring-0"
                                            placeholderText="Set Date & Time"
                                            selected={validationTillDateField?.value}
                                            disabled={!expirationTimeField?.value}
                                            onChange={(date) => {
                                                if (expirationTimeField?.value)
                                                    validationTillDateField?.onChange(date);
                                                return;
                                            }}
                                            dateFormat="MMMM d, yyyy h:mmaa"
                                            timeIntervals={15}
                                        />
                                        {errors.validationTillDate && (
                                            <p className="text-foundryRed">
                                                {errors.validationTillDate.message}
                                            </p>
                                        )}
                                    </div>
                                </div>}

                            </>

                            <div className="flex items-center mt-5 gap-3">
                                <ButtonNew
                                    type={'submit'}
                                    disabled={loading}
                                    fixedMinWidth={true}
                                    variant="blue"
                                    shape='oval'
                                    size="sm"
                                    onClick={onSubmit}
                                >
                                    {loading ? <Loader /> : 'Re-publish'}
                                </ButtonNew>
                                <ButtonNew
                                    type='button'
                                    fixedMinWidth={true}
                                    variant="neutral"
                                    shape='oval'
                                    size="sm"
                                    onClick={close}
                                >
                                    Cancel
                                </ButtonNew>

                            </div>
                        </form>
                    </div>

                </ModalBox>
            </div>
        </Overlay>,
        document.getElementById('modal-root')
    );
}

export default RePublishBountyModal;
